import React from 'react'

import { reactionEventEmitter, reactionKeys } from 'helpers/events'
import { sendEmoji } from 'services/webSockets/reactions'

const useEmoji = (isLocal, identity) => {
    const [emojiData, setEmojiData] = React.useState({
        show: false,
        id: null,
    })

    React.useEffect(() => {
        let timeoutHandler

        const handler = ({ reactionId, sender }) => {
            if (
                (isLocal && !sender) ||
                (!isLocal && sender === identity.uuid)
            ) {
                setEmojiData({
                    show: true,
                    id: { id: reactionId },
                })
            }

            if (isLocal && !sender) {
                // broadcast websocket message
                sendEmoji(reactionId)
            }

            timeoutHandler = setTimeout(() => {
                setEmojiData({
                    show: false,
                    id: null,
                })
            }, 2000)
        }

        reactionEventEmitter.addListener(reactionKeys.SHOW_REACTION, handler)

        return () => {
            reactionEventEmitter.removeListener(
                reactionKeys.SHOW_REACTION,
                handler
            )

            if (timeoutHandler) {
                clearTimeout(timeoutHandler)
            }
        }
    }, [])

    return emojiData
}

export { useEmoji }
